import PropTypes from 'prop-types'
import { DownloadSimple, Plus } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import SearchField from '../../FormLegacy/FormFieldsV2/SearchField'
import { makeAttendeeStatus } from '../utils'

const TableFilters = ({
  search,
  onSearchChange,
  selectedTab,
  onSelectedTab,
  onDownloadClick,
  onAddAttendee,
  canAddAttendee,
}) => {
  const { t } = useTranslation(['attendees'])
  const attendeeStatus = makeAttendeeStatus(t)

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value
    onSearchChange(searchTerm)
  }

  return (
    <div className="attendees_table-filters">
      <div className="navbar-tabs">
        {Object.values(attendeeStatus).map((tab) => (
          <div
            className={`tab ${tab.value === selectedTab ? 'active' : ''}`}
            key={tab.value}
            onClick={() => {
              onSelectedTab(tab.value)
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className="right-wrapper">
        {canAddAttendee && (
          <button className="button button-primary" onClick={onAddAttendee}>
            {t('attendees:tableFilters.addAttendee')}
            <Plus size={20} />
          </button>
        )}
        <SearchField
          placeholder={t('attendees:tableFilters.searchPlaceholder')}
          value={search}
          onChange={handleSearchChange}
        />
        <button className="button button-transparent" onClick={onDownloadClick}>
          <DownloadSimple size={20} />
        </button>
      </div>
    </div>
  )
}

TableFilters.propTypes = {
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  selectedTab: PropTypes.string,
  onSelectedTab: PropTypes.func,
  onDownloadClick: PropTypes.func,
  onAddAttendee: PropTypes.func,
  canAddAttendee: PropTypes.bool,
}

export default TableFilters
